import { motion } from 'framer-motion';

const allies = [
  { icon: 'account_balance', label: 'Bancos' },
  { icon: 'payments', label: 'PSPs' },
  { icon: 'currency_exchange', label: 'EMIs' },
  { icon: 'assured_workload', label: 'MSBs' },
  { icon: 'lan', label: 'Redes de Pago' },
  { icon: 'memory', label: 'Procesadores' },
  { icon: 'point_of_sale', label: 'Adquirentes' },
];

export default function LogoBar() {
  return (
    <section className="py-14 bg-transparent">
      <div className="mx-auto min-w-0 max-w-5xl px-4 text-center sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="material-symbols-outlined text-purple-primary text-[28px]">hub</span>
            <p className="text-2xl md:text-3xl font-black font-headline text-white">
              +11 <span className="gradient-text">Aliados Financieros</span>
            </p>
          </div>
          <p className="text-on-surface-variant text-base md:text-lg max-w-xl mx-auto leading-relaxed">
            Una única plataforma tecnológica conectada a más de 11 entidades financieras reguladas.
            PSPs, EMIs, bancos y MSBs trabajando detrás de su concierge.
          </p>
          <div className="flex flex-wrap justify-center gap-3 mt-8">
            {allies.map((ally, i) => (
              <motion.div
                key={ally.label}
                className="flex items-center gap-2 px-5 py-2.5 rounded-xl bg-gradient-to-r from-purple-primary/10 to-accent-magenta/5 border border-purple-primary/25 group cursor-default"
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.06, duration: 0.4 }}
                whileHover={{ borderColor: 'rgba(210,60,179,0.5)', backgroundColor: 'rgba(168,67,151,0.12)', scale: 1.05 }}
              >
                <span className="material-symbols-outlined text-purple-primary text-[18px] group-hover:text-accent-magenta transition-colors duration-300">{ally.icon}</span>
                <span className="text-xs font-bold text-on-surface-variant/80 group-hover:text-white font-label uppercase tracking-wider transition-colors duration-300">{ally.label}</span>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
